import { formatPoints } from "./display";
export const campaignRuleDescription = (rule) => {
  const points = formatPoints(rule.pontos_bonus || 0);
  const product = rule.produto_nome || rule.produto || rule.codigo_produto_erp || rule.sku || "não informado";
  const brand = rule.nome_marca || rule.marca || rule.codigo_marca_erp || "não informada";
  switch (rule.type) {
    case "valor_minimo": return `+${points} pontos em vendas a partir de ${Number(rule.valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}.`;
    case "item_bonificado": case "produto_especifico": case "produto_bonificado": return `+${points} pontos pelo item elegível: ${product}.`;
    case "marca_bonificada": return `+${points} pontos pelo item elegível da marca ${brand}.`;
    case "multiplicador": return `${rule.multiplicador || 1}x a pontuação-base da venda.`;
    case "primeira_venda": return `+${points} pontos na primeira venda elegível.`;
    default: return "Condição especial. Confirme os detalhes com a loja.";
  }
};
